// Carries PENDING_MAPPING accounts from /exchange to the Bank Connections tab:
// the list endpoint omits unmapped rows and the OAuth redirect loses React state.

const STORAGE_KEY = "wieldy.plaid.pendingMapping";

export function savePendingMappingConnections(
  connections: PlaidConnectionMessage[],
): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(connections));
  } catch {
    // Storage unavailable (private mode/quota) — direct flow still works via refresh.
  }
}

export function loadPendingMappingConnections(): PlaidConnectionMessage[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PlaidConnectionMessage[]) : [];
  } catch {
    return [];
  }
}

export function clearPendingMappingConnections(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
}
